




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import SaveBrandBookmarkPopup from '@/components/BrandBookmarks/SaveBrandBookmarkPopup.vue';
import { Brand, BrandIndexItem, BrandQueryResultItem } from '@/api/braendz';

@Component({
    components: {
        SaveBrandBookmarkPopup
    }
})
export default class BookmarkBrandButton extends Vue {
    // Data
    public showPopup = false;

    // Properties
    @Prop({ required: true })
    public type!: 'icon' | 'list-item';

    @Prop({ required: true })
    public brand!: BrandQueryResultItem | BrandIndexItem | Brand | null | undefined;

    // Getter
    public get brandId(): string | null {
        return this.$braendz.getBrandId(this.brand);
    }

    // Methods
    public openPopupOrSignIn(): void {
        if(this.$store.getters.isUserAuthenticated()) {
            this.showPopup = true;
        }
        else {
            this.$auth.signIn();
        }
    }
}
